// colors
export var autofillColor = "rgb(250, 255, 189)";
export var autofillColorSelected = "rgb(232, 240, 254)";
export var baseFontColor = "#2C2C2C";
export var baseFontColorSemiTransparent = "rgba(50,50,50,0.6)";
export var baseFontColorTransparent = "rgba(50,50,50,0.1)";
export var borderGray = "#CFD7DA";
export var borderGrayOpacity = "rgba(79, 110, 124, 0.1)";
export var black = "#323232";
export var blackDeep = "#000000";
export var blue = "rgb(33,18,94)";
export var blueDark = "#190c4e";
export var blueDarkLighten = "#4f6e7c";
export var hoverBlueDarkLighten = "#3b5a68";
export var activeBlueDarkLighten = "#31505e";
export var blueLight = "#513CA3";
export var blueLightSemi = "#F6F7F8";
export var blueOverlay = "rgba(33,18,94,0.1)";
export var blueOverlayDark = "rgba(33,18,94,0.2)";
export var gray = "#7d7d7d";
export var graySemi = "#839098";
export var graySemiOpacity = "rgba(79, 110, 124, 0.5)";
export var grayMedium = "#c4c4c4";
export var grayDark = "#323232";
export var graySoft = "#E2E3E4";
export var grayLight = "#f5f1f2";
export var grayLabel = "rgba(44, 44, 44, 0.5)";
export var green = "#3ed256";
export var overlayColor = "rgba(44, 44, 44, 0.4)";
export var rose = "#c22d74";
export var turquoise = "#13bebb";
export var turquoiseDark = "#06a09e";
export var turquoiseLight = "rgba(6, 132, 123, 0.25)";
export var turquoiseTransparent = "rgba(6, 132, 123, 0.1)";
export var white = "#fff";
export var tabelGray = "#eaeaea";
export var darkGreen = "#06847B";
export var red = "#c34c3e";
export var redLight = "#F5F1F2";
export var hoverRed = "#af382a";
export var activeRed = "#a52e20"; // theme colors

export var theme = {
  activeMenuOption: darkGreen,
  autofill: autofillColor,
  autofillSelected: autofillColorSelected,
  baseFont: baseFontColor,
  baseFontColorSemiTransparent: baseFontColorSemiTransparent,
  baseFontColorTransparent: baseFontColorTransparent,
  blackDeep: blackDeep,
  blueLightSemi: blueLightSemi,
  borderGray: borderGray,
  borderGrayOpacity: borderGrayOpacity,
  dark: black,
  disabled: gray,
  divider: grayLight,
  dividerDark: grayMedium,
  error: rose,
  grayLabel: grayLabel,
  graySemi: graySemi,
  graySemiOpacity: graySemiOpacity,
  graySoft: graySoft,
  hoverLightBackground: turquoiseLight,
  hoverRed: hoverRed,
  light: grayLight,
  lightFont: gray,
  listAttributeName: baseFontColorSemiTransparent,
  listBullet: darkGreen,
  overlay: overlayColor,
  primary: red,
  primaryDark: hoverRed,
  primaryDarkest: activeRed,
  primaryLight: turquoiseLight,
  primaryTransparent: turquoiseTransparent,
  red: red,
  redLight: redLight,
  secondary: blueDarkLighten,
  secondaryDark: hoverBlueDarkLighten,
  secondaryDarkest: activeBlueDarkLighten,
  secondaryLight: blueLight,
  secondaryOverlay: blueOverlay,
  secondaryOverlayDark: blueOverlayDark,
  success: green,
  tabTitle: darkGreen,
  tableDivider: tabelGray,
  tabsBorder: baseFontColorTransparent,
  thumbnailBorder: darkGreen,
  white: white
}; // typography

export var baseFontFamily = "'Sofia', Arial, Helvetica, sans-serif";
export var thinFontFamily = "'Sofia thin', Arial, Helvetica, sans-serif";
export var boldFontFamily = "'Sofia bold', Arial, Helvetica, sans-serif";
export var extraFontFamily = "'Inter', Arial, Helvetica, sans-serif";
export var baseFontSize = "1rem"; // 16px

export var baseLineHeight = "1.25rem"; // 20px

export var boldFontWeight = 600;
export var extraBoldFontWeight = 800;
export var h1FontSize = "4rem"; // 64px

export var h2FontSize = "3rem"; // 48px

export var h1LineHeight = 1;
export var h3FontSize = "1.5rem"; // 24px

export var h4FontSize = "1.125rem"; // 18px

export var labelFontSize = "0.75rem"; // 12px

export var smallFontSize = "0.875rem"; // 14px

export var ultraBigFont = "6rem"; // 96px
// spacing

export var spacer = 1; // rem

export var fieldSpacer = "1.875rem"; // breakpoints

export var xxxLargeScreen = 1919;
export var xxLargeScreen = 1599;
export var xLargeScreen = 1279;
export var largeScreen = 992;
export var mediumScreen = 767;
export var smallScreen = 540;
export var extraSmallScreen = 375;